import { DoubleLeftOutlined } from "@ant-design/icons";

import config from "../../../config";

import { HeadSiderTitle, IconMenuButton, MenuHeader } from "./styledComponents";

export const HeadSider = ({
  collapsed,
  onCollapse,
}: {
  collapsed: boolean;
  onCollapse: () => void;
}) => {
  const isStaging = config.VITE_APP_ENV === "staging";

  return (
    <MenuHeader isStaging={isStaging}>
      <img
        src="https://cdn.smarta.tax/images/smarta-s-icon.svg"
        alt="Smarta Logo"
        className="smarta-logo"
        width="20"
        height="20"
      />
      {isStaging && !collapsed && <HeadSiderTitle>Staging</HeadSiderTitle>}
      <IconMenuButton
        shape="circle"
        icon={<DoubleLeftOutlined />}
        onClick={onCollapse}
        className="arrow"
        size="small"
      />
    </MenuHeader>
  );
};
